import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as FlightEventsService from "_services/flight-events-service";

/**
 * Get flight events / airport updates
 * Returns flight event data for a given time range
 */
export const getFlightEvents = createAsyncThunk(
    "flightEvents/getFlightEvents",
    async ({ iata, startTime, endTime }) => {
        return FlightEventsService.getFlightEvents({
            iata,
            startTime,
            endTime,
        });
    }
);

const flightEventsSlice = createSlice({
    name: 'flightEvents',
    initialState: {
        events: [],
        startDate: null,
        endDate: null,
        status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
        error: null,
    },
    reducers: {
        reset: (state) => {
            state.events = [];
            state.startDate = null;
            state.endDate = null;
            state.status = 'idle';
            state.error = null;
        },
        setStartDate: (state, action) => {
            state.startDate = action.payload;
        },
        setEndDate: (state, action) => {
            state.endDate = action.payload;
        },
    },
    extraReducers: {
        [getFlightEvents.pending]: (state, action) => {
            state.status = "loading";
            state.error = null;
        },
        [getFlightEvents.fulfilled]: (state, action) => {
            state.status = "succeeded";
            state.events = action.payload || [];
        },
        [getFlightEvents.rejected]: (state, action) => {
            state.status = "failed";
            state.events = [];
            state.error = action.error.message;
        },
    }
});

export const { reset, setStartDate, setEndDate } = flightEventsSlice.actions;

export default flightEventsSlice.reducer;

// Selectors
export const selectFlightEvents = state => state.flightEvents.events;
export const selectFlightEventsStatus = state => state.flightEvents.status;
export const selectFlightEventsError = state => state.flightEvents.error;
export const selectFlightEventsStartDate = state => state.flightEvents.startDate;
export const selectFlightEventsEndDate = state => state.flightEvents.endDate;
